import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LogoutComponent implements OnInit {

  constructor(private auth: AuthService, private readonly router: Router) {
  }

  ngOnInit(): void {
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin + '/logged-out',
      },
    });
  }

}
